// newAssetItems — what the "New asset" menu offers, as data.
//
// Separate from NewAssetMenu.jsx for two reasons. It is the CONTRACT with
// ContentBrowser, which dispatches on the key ('material-pbr',
// 'blueprint-body', …), so it deserves tests of its own — and a .jsx module
// cannot be imported by node --test at all.
//
// Kinds are GROUPED: four Material rows and three Blueprint rows made a
// thirteen-item flat list in which seven entries were really two decisions, and
// the shared prefix ("Material — …") put the part that actually differs at the
// far right of the label, the hardest place to scan. So the family is the
// top-level row and the variant lives one level in. That is presentation only —
// the keys below are exactly the keys from before the regrouping.
//
// A row either picks a key or opens a group, never both: a row with both would
// be ambiguous on click (pick, or expand?).

/**
 * @param {object} [opts]
 * @param {boolean} [opts.orgEnvironments] the org-environments feature flag.
 *   A parameter rather than a call into featureFlags, so this module imports
 *   nothing and the menu's shape can be tested without a DOM or localStorage.
 */
export function getNewAssetItems({ orgEnvironments = false } = {}) {
  const items = [
    { key: 'upload',        label: 'Upload',   hint: 'GLB / WAV / JSON / image' },
    { key: 'folder',        label: 'Folder',   hint: '' },
    {
      group: 'material', label: 'Material', hint: 'Shader / surface',
      children: [
        { key: 'material-pbr',   label: 'PBR',   hint: 'Preset graph: base color, normal, rough/metal, AO, emissive' },
        { key: 'material-graph', label: 'Graph', hint: 'Custom shader graph' },
      ],
    },
    { key: 'prefab',        label: 'Prefab',   hint: 'Bundle of animations + audio' },
    {
      group: 'blueprint', label: 'Blueprint', hint: 'One graph per card',
      children: [
        { key: 'blueprint-body',   label: 'Body graph',  hint: 'A body animation graph' },
        { key: 'blueprint-face',   label: 'Face graph',  hint: 'A face animation graph' },
        { key: 'blueprint-events', label: 'Event graph', hint: 'A conversation / logic graph' },
      ],
    },
    { key: 'generate-anim', label: 'Generate animation', hint: 'Text prompt → kimodo' },
    { key: 'ogs',           label: 'OGS bundle', hint: 'Upload inference files' },
    { key: 'rig',           label: 'Replace Rig', hint: 'Destructive', danger: true },
  ]
  if (orgEnvironments) {
    items.push({ key: 'upload-environment', label: 'Upload environment', hint: '.ply / .splat' })
  }
  return items
}

/** Every key the menu can emit, groups flattened. */
export function newAssetKeys(opts) {
  return getNewAssetItems(opts).flatMap((i) => (i.children ? i.children.map((c) => c.key) : [i.key]))
}
